// extracted by mini-css-extract-plugin
export default {"divider":"Conversation_divider__in-UW","row":"Conversation_row__Uj5aJ","video":"Conversation_video__N1bqH","error":"Conversation_error__4wnYm"};